/**
 * Mapa de rotas → chave do módulo em HelpPage MODULES.
 * Testado contra as rotas definidas em `/app/frontend/src/config/routes.js`.
 *
 * Regras de resolução (ver resolveHelpKey):
 *   1. Correspondência exacta (ex.: "/service-cases")
 *   2. Correspondência por prefixo (ex.: "/service-cases/abc-123" → "som")
 *   3. Fallback: null (botão esconde-se)
 */
export const ROUTE_HELP_MAP = {
  // Logística
  "/logistics": "logistics",
  "/vehicles": "logistics",

  // Administração / Produtividade
  "/anuncios": "announcements",
  "/announcements": "announcements",
  "/scope": "scope",

  // Operacional
  "/": "panel",
  "/painel": "panel",
  "/dashboard": "panel",
  "/branch-map": "branch_map",
  "/mapa": "branch_map",
  "/workshop-board": "workshop_board",
  "/oficina": "workshop_board",
  "/service-cases": "som",
  "/body-shop-cases": "swc",
  "/body-shop-cases/board": "bps_board",
  "/body-shop-cases/calendar": "bps_board",
  "/bps-board": "bps_board",
  "/tasks": "tasks",
  "/parts-requests": "pcp",
  "/parts-bench-orders": "peb",
  "/customer-feedback": "feedback",
  "/feedback": "feedback",
  "/classification-requests": "pec",
  "/warranty-claims": "warranty",
  "/maintenance-plans": "mpm",

  // Recepções / Comercial
  "/vehicle-registrations": "vr",
  "/vr": "vr",

  // CRM
  "/customers": "crm",
  "/opportunities": "crm",

  // Reportes
  "/reports": "reports",
  "/analytics": "reports",

  // Help
  "/ajuda": "automations",
  "/help": "automations",
};


/** Resolve o módulo de ajuda a mostrar para uma rota activa. */
export function resolveHelpKey(pathname) {
  if (!pathname) return null;
  // 1. match exacto
  if (ROUTE_HELP_MAP[pathname]) return ROUTE_HELP_MAP[pathname];
  // 2. prefix match — ordena por tamanho desc. para dar prioridade ao mais específico
  const prefixes = Object.keys(ROUTE_HELP_MAP).sort((a, b) => b.length - a.length);
  for (const p of prefixes) {
    if (p === "/") continue; // "/" é só para match exacto
    if (pathname === p || pathname.startsWith(p + "/")) {
      return ROUTE_HELP_MAP[p];
    }
  }
  return null;
}
